import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Highcharts from "highcharts";
import HighchartsVue from "highcharts-vue";
import moreInit from "highcharts/highcharts-more";
import bellcurveInit from "highcharts/modules/histogram-bellcurve";
import heatmapInit from "highcharts/modules/heatmap";
import treemapInit from "highcharts/modules/treemap";
import solidgaugeInit from "highcharts/modules/solid-gauge";
import sankeyInit from "highcharts/modules/sankey";
import itemseriesInit from "highcharts/modules/item-series";
import drilldownInit from "highcharts/modules/drilldown";
import exportingInit from "highcharts/modules/exporting";
import offlineExportingInit from "highcharts/modules/offline-exporting";
import exportDataInit from "highcharts/modules/export-data";
import highchartsTheme from "@/plugins/highcharts-theme";
import mapInit from "highcharts/modules/map";

//import vueAnalytics from "vue-analytics";
import VueGtag from "vue-gtag";
import "@babel/polyfill";
import "@/assets/fonts/fonts.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import VueIntro from "vue-introjs";

Vue.config.productionTip = false;

Highcharts.setOptions(highchartsTheme);
moreInit(Highcharts);
bellcurveInit(Highcharts);
heatmapInit(Highcharts);
treemapInit(Highcharts);
solidgaugeInit(Highcharts);
sankeyInit(Highcharts);
itemseriesInit(Highcharts);
drilldownInit(Highcharts);
exportingInit(Highcharts);
offlineExportingInit(Highcharts);
exportDataInit(Highcharts);
mapInit(Highcharts);
Vue.use(HighchartsVue);

Vue.use(VueIntro);

// Configuration VueAnalytics

const getGDPR = localStorage.getItem("GDPR:accepted");

if (typeof getGDPR !== "undefined" && getGDPR === "true") {
  Vue.use(VueGtag, {
    config: {
      id: "UA-159140386-1",
      enabled: true
    }
  });
} else if (typeof getGDPR !== "undefined" && getGDPR === "false") {
  Vue.use(VueGtag, {
    config: {
      id: "UA-159140386-1",
      enabled: false
    }
  });
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
